import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-error-middleware',
  templateUrl: './login-error-middleware.component.html',
  styleUrls: ['./login-error-middleware.component.css']
})
export class LoginErrorMiddlewareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
